import { render, staticRenderFns } from "./dingdWxlist.vue?vue&type=template&id=89ea4284&scoped=true"
import script from "./dingdWxlist.vue?vue&type=script&lang=js"
export * from "./dingdWxlist.vue?vue&type=script&lang=js"
import style0 from "./dingdWxlist.vue?vue&type=style&index=0&id=89ea4284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ea4284",
  null
  
)

export default component.exports